export default __webpack_public_path__ + "static/media/menu-sprite.8524cecd.svg";